<template>
  <div
    class="bulk-discount"
    v-if="isBulkDiscount"
  >
    <img
      class="bulk-discount__image"
      src="@/assets/offer/apply-now.png"
      alt=""
    >
    <p
      class="bulk-discount__title"
      @click="showNewMessage()"
    >
      You’ve qualified for bulk discounts. Would you like to apply?
      <span
        class="bulk-discount__button"
      >
        Apply Discount
      </span>
    </p>
  </div>
</template>

<script setup>
import { useIntercom } from '@/hooks/useIntercom'
import { useBulkDiscount } from '@/views/Carts/hooks/useBulkDiscount'

const { isBulkDiscount } = useBulkDiscount()
const { showNewMessage } = useIntercom()
</script>

<style lang="less" scoped>
.bulk-discount {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: linear-gradient(90deg, #141414 0%, #523C2A 100%);
  border-radius: 8px 8px 0 0;

  &__image {
    width: 32px;
    height: 32px;
  }

  &__title {
    font-family: mon-500;
    font-size: 11px;
    line-height: 16px;
    color: #FFFFFF;
  }

  &__button {
    margin-left: 6px;
    color: #66C4EC;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
